import { Event } from "../../types/events";

export const amITheEventPilote = (event?: Event, userKeycloakId?: string) => {
  if (!event?.pilotes?.[0] || !userKeycloakId) {
    return false;
  }
  return event.pilotes[0].keycloakId === userKeycloakId;
};
